import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


interface Emits {
(e:'click'):void
}

export default /*#__PURE__*/_defineComponent({
  emits: ["click"],
  setup(__props, { emit: emtis }: { emit: ({
(e:'click'):void
}), expose: any, slots: any, attrs: any }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "rounded-lg flex items-center cursor-pointer h-10 box-border border",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emtis('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})